import { render, staticRenderFns } from "./Setari_sms.vue?vue&type=template&id=54b9ab64&scoped=true"
import script from "./Setari_sms.vue?vue&type=script&lang=js"
export * from "./Setari_sms.vue?vue&type=script&lang=js"
import style0 from "./Setari_sms.vue?vue&type=style&index=0&id=54b9ab64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b9ab64",
  null
  
)

export default component.exports